const PALAVRAS_DE_NEGACAO = new Set(['NOT', 'NAO', 'NÃO']);
const TOKENS_POSITIVOS = ['READ', 'SEEN', 'DELIVERED', 'SENT', 'RESPONDED'];

/**
 * O status de comunicação NEGA o que um token positivo afirmaria? (review do PR #1160, COR-03)
 *
 * Os classificadores de status casam por substring, e precisam: `FAIL` tem de pegar `FAILED`,
 * `BLOQUEAD` pegar `BLOQUEADO`, e `CIENCIA_CONFIRMADA` tem underscore. O custo do substring é que
 * a negação some: `NOT_DELIVERED` contém `DELIVERED` e saía ✓✓, `UNREAD` contém `READ` e virava
 * ciência confirmada. Num certificado probatório isso é o documento afirmando entrega ou leitura
 * que não houve.
 *
 * Por isso a negação é checada à parte, por palavra, e só vale contra afirmações POSITIVAS: quem
 * chama testa a falha antes — `UNDELIVERABLE` começa com `UN` e é justamente uma afirmação de
 * falha, assim como o "Não entregue" que o back traduz a partir dele.
 */
export function negaAfirmacao(status: string): boolean {
  return status
    .toUpperCase()
    .split(/[^\p{L}]+/u)
    .some(
      (palavra) =>
        PALAVRAS_DE_NEGACAO.has(palavra) ||
        (palavra.startsWith('UN') && TOKENS_POSITIVOS.some((t) => palavra.slice(2).startsWith(t))),
    );
}
